<template>
    <div class="center-page">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="路线" name="2"></el-tab-pane>
            <el-tab-pane label="景点" name="3"></el-tab-pane>
            <el-tab-pane label="温泉" name="4"></el-tab-pane>
            <el-tab-pane label="美食" name="5"></el-tab-pane>
        </el-tabs>
        <div class="card-list" v-loading="loading">
            <el-card v-for="item in evaluates" :key="item.id" :body-style="{ padding: '0px'}" class="card-list-item">
                <img :src="`/api/v1/file/${item.cover}`" class="image">
                <div style="padding: 14px;">
                    <div class="line-clamp-1" style="width: 300px;">{{item.title}}</div>
                    <div class="evaluate-content">
                        <el-rate :value="+item.star|| 0"
                                 disabled
                                 show-score
                                 disabled-void-color="#cccccc"
                                 text-color="#ff9900"
                                 style="display: flex;justify-content: flex-start;align-items: center"
                                 score-template="{value}"></el-rate>
                        <div class="f-14">{{item.evaluate_count}} 评价</div>
                    </div>
                    <div class="bottom clearfix">
                        <el-button type="text" class="button" @click="toList(item)">查看全部评价</el-button>
                    </div>
                </div>
            </el-card>
        </div>
        <el-alert v-if="evaluates.length<=0" title="暂无数据~" center :closable="false" type="warning" show-icon></el-alert>
    </div>
</template>

<script>
    export default {
        name: "dirverEvaluate",
        data() {
            return {
                loading: false,
                activeName: '2',
                evaluates: []
            }
        },
        created() {
            this.houseEvaluate();
        },
        methods: {
            async handleClick() {
                this.houseEvaluate();
            },
            async houseEvaluate() {
                this.loading = true;
                let [e, data] = await this.$api.houseEvaluateApi({state: this.activeName})
                this.loading = false;
                this.evaluates = data.result.evaluates;
            },
            toList(item) {
                this.$router.push({
                    path: '/center/evaluateList', query: {id: item.id, state: this.activeName}
                })
            }
        },
    }
</script>

<style scoped lang="less">
    .card-list {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;

        .card-list-item {
            margin-right: 6px;
            margin-bottom: 10px;

            .image {
                width: 300px;
                height: 300px;
                object-fit: cover;
            }

            .evaluate-content {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-top: 10px;
            }
        }
    }

</style>

